import { create } from "zustand";

type ThemeMode = "auto" | "light" | "dark";

interface ThemeStore {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

function applyTheme(mode: ThemeMode) {
  const html = document.documentElement;
  if (mode === "auto") {
    html.removeAttribute("data-theme");
  } else {
    html.setAttribute("data-theme", mode);
  }
}

function getInitialMode(): ThemeMode {
  if (typeof window === "undefined") return "auto";
  const stored = localStorage.getItem("genmov-theme");
  if (stored === "light" || stored === "dark") return stored;
  return "auto";
}

export const useThemeStore = create<ThemeStore>((set) => {
  const initial = getInitialMode();
  if (typeof window !== "undefined") {
    applyTheme(initial);
  }

  return {
    mode: initial,
    setMode: (mode) => {
      localStorage.setItem("genmov-theme", mode);
      applyTheme(mode);
      set({ mode });
    },
  };
});
